// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"264":"b3f372d9","418":"931023e4","453":"8ab44547","480":"d222b4bf","638":"b02228b2","854":"692201c8"}[chunkId] + ".chunk.js";
};